/* global locale */
/**
 * doGeocode initializes geocoding. Geocoding is done in a web worker so that
 * for large geocoding processes you can go to other tabs and do things and the
 * browser wont slow down the timeouts we use. Web Workers with timeouts don't
 * slow down at all but timeouts in the main thread that are backgrounded slow
 * to around 1 iteration a second.
 *
 * It doesn't take any args and returns nothing. It just handles the worker. If
 * called a 2nd time it will ask to stop the current process. Called a 3rd time
 * it will behave like the first time and run geocoding again.
 */
(function () {
  // If we're on IE9 return out of this file right away for now. Google Maps is
  // stopping support for IE9 in April but in the meantime just disable pro
  // geocoding in IE9.
  if (BatchGeo.isIE() === 9) return;

  // intervals
  let showProcessingInterval;
  let getResultsInterval;

  // shared state
  let ip_addr = false;
  let outliers = [];
  let outliersByRowIndex = {};
  let cogLatLon;
  let validRM;
  let rgn = "us";
  let breakcache;
  let rvals = [];
  let recommendedBounds;
  let outliersStargingLength;
  let resultsHandled = 0;

  // status
  let showCount = 0;
  let remaining;
  let ended = false;
  let statusText = "";

  // choropleth
  const detailLevels = {};
  const accuracyLevels = {};
  const indeterminateResults = [];
  const mismatches = [];
  const boundaries = {
    country: "COUNTRY",
    administrative_area_level_1: "ADMINISTRATIVE_AREA_LEVEL_1",
    administrative_area_level_2: "ADMINISTRATIVE_AREA_LEVEL_2",
    locality: "LOCALITY",
    postal_code: "POSTAL_CODE",
  };
  let detailLevel;
  let displayChoroplethOption = false;

  const resetSharedGeocodeState = () => {
    outliers = [];
    outliersByRowIndex = {};
    recommendedBounds = null;
    validRM = null;
    cogLatLon = null;
    ip_addr = false;
    rgn = $("#country_sel").val();
    breakcache = Boolean($("#breakcache_cb")[0]?.checked);
  };

  const handleResult = (r, status, results) => {
    const rM = window.per.mapRS[r];
    if (!rM) return;

    if (rM && !breakcache && BatchGeo.goodLatLon(rM.lt, rM.ln)) {
      // already had coords, don't need geocode
      // TODO(tom) not sure what this is supposed to do?
      // rM.lt = rM.lt;
      // rM.ln = rM.ln;
      if (!rM.accuracy) rM.accuracy = google.maps.GeocoderLocationType.ROOFTOP;
    } else if (!status && results && results.ip && results.latitude) {
      rM.lt = results.latitude;
      rM.ln = results.longitude;
      rM.postal = results.zipcode;
      rM.l = (
        BatchGeo.ifstr(results.city) +
        " " +
        BatchGeo.ifstr(results.region_name) +
        " " +
        BatchGeo.ifstr(results.zipcode) +
        " " +
        BatchGeo.ifstr(results.country_name)
      ).trim();
      rM.accuracy = google.maps.GeocoderLocationType.APPROXIMATE;
    } else if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
      // TODO(tom) these are never used, need to do something on limit?
      // overQuota++;
      // lastTime = (new Date()).getTime();
    } else if (status != google.maps.GeocoderStatus.OK) {
      rM.lt = 0;
      rM.ln = 0;
      rM.accuracy = "unknown";
      rM.invalid = true;
    } else if (status == google.maps.GeocoderStatus.OK) {
      rM.ln = results.geometry.location.lng;
      rM.lt = results.geometry.location.lat;
      rM.postal = "";
      try {
        // TODO(tom) locale is from php global var
        if (locale != "us" && results) rM.l = results.formatted_address;
      } catch (err) {
        console.log(`Error setting rM.l ${err}`);
      }
      rM.accuracy = results.geometry.location_type;
      if (rM.accuracy != google.maps.GeocoderLocationType.APPROXIMATE)
        window.succCount++;
    }

    if (BatchGeo.goodLatLon(rM.lt, rM.ln)) {
      window.gC[rgn][rM.addr] = {
        lt: rM.lt,
        ln: rM.ln,
        accuracy: rM.accuracy,
        l: rM.l,
      };
    }

    rM.placeId = results.place_id;

    window.gbounds.extend(new google.maps.LatLng(rM.lt, rM.ln));
    rM.tO = 0;
  };

  const handleResults = (resultsData) => {
    let received = [];
    const startTime = new Date().getTime();
    const seenResults = {};

    if (!resultsData.results) {
      return window.stopGeocode();
    }

    for (let i = 0; i < resultsData.results.length; i++) {
      let results = resultsData.results[i];
      const r = rvals[results.r];
      const status = results.status;
      if (status === google.maps.GeocoderStatus.OK || results.ip) {
        if (r) {
          window.prepRow(r);
        }

        if ("undefined" !== typeof results.results) {
          if (results.results.length > 1) {
            indeterminateResults.push(results);
            seenResults[r] = 1;
            resultsHandled++;
            continue;
          } else {
            results = results.results[0];
          }
        }

        if (results) {
          if (results.types) {
            results.types.forEach((type) => {
              if (type !== "political") {
                if (detailLevels[type]) {
                  detailLevels[type].push(r);
                } else {
                  detailLevels[type] = [r];
                }
              }

              if (accuracyLevels[results.geometry.location_type]) {
                accuracyLevels[results.geometry.location_type]++;
              } else {
                accuracyLevels[results.geometry.location_type] = 1;
              }
            });
          }

          if ("undefined" === typeof seenResults[r]) {
            handleResult(r, status, results);
            resultsHandled++;
            seenResults[r] = 1;
            if (resultsHandled === window.per.mapRS.length) {
              const curTime = new Date().getTime();
              window.per.gps =
                window.per.addrs_len / ((curTime - startTime) / 1000);
            }
          }

          if (resultsHandled % 1000 === 0) {
            let sum = 0;
            for (let k = 0; k < received.length; k++) {
              sum += parseInt(received[k], 10);
            }

            const avg = sum / received.length;
            let gps = (received.length * avg) / (1.5 * received.length);
            if (received.length > 5) {
              received = [];
            }

            if (gps > 150) {
              gps = 150;
            }

            remaining = Math.round(
              (window.per.addrs_len - resultsHandled) / gps + 2,
            );
          }
        }
      } else {
        resultsHandled++;
        seenResults[r] = 1;
      }
    }

    if (resultsData.status == "done") {
      ended = true;
      let detailLevelKey;
      let mapRenderType = { type: "marker" };

      if (!_.isEmpty(accuracyLevels)) {
        statusText = "Determining detail level";
        const accuracyLevel = Object.entries(accuracyLevels).reduce(
          (prev, current) => (prev && prev[1] > current[1] ? prev : current),
        );

        detailLevelKey = Object.entries(detailLevels).reduce((prev, current) =>
          prev && prev[1].length > current[1].length ? prev : current,
        )[0];

        detailLevel = boundaries[detailLevelKey];
        if (
          accuracyLevel[0] === "APPROXIMATE" &&
          accuracyLevel[1] /
            Object.values(accuracyLevels).reduce((a, b) => a + b, 0) >=
            0.7 &&
          detailLevel
        ) {
          if (!BatchGeoStore.getState().App.isEdit) {
            displayChoroplethOption = true;
          } else {
            mapRenderType.type = "choropleth";
            mapRenderType.detailLevel = detailLevel;
          }
        }

        window.per.map_render_type = mapRenderType;
      }

      if (indeterminateResults.length) {
        statusText = "Handling indeterminate results.";
        indeterminateResults.forEach((geocode) => {
          let match;
          const r = rvals[geocode.r];
          const status = geocode.status;
          if (displayChoroplethOption) {
            // if choropleth find best match based on detail level
            match = geocode.results.find((result) =>
              result.types.includes(detailLevelKey),
            );
          } else {
            // if marker map find best match based on address components
            const addr = window.per.mapRS[r].addr;
            let matches = {};
            geocode.results.forEach((result, i) => {
              matches[i] = 0;
              result.address_components.forEach((component) => {
                if (
                  addr.includes(component.long_name) ||
                  addr.includes(component.short_name)
                ) {
                  matches[i]++;
                }
              });
            });

            const bestMatch = Object.entries(matches).reduce((prev, current) =>
              prev && prev[1] > current[1] ? prev : current,
            )[0];
            match = geocode.results[bestMatch];
          }

          if (match) {
            handleResult(r, status, match);
          } else {
            // no match, just take the first result
            handleResult(r, status, geocode.results[0]);
          }
        });
      }

      // eslint-disable-next-line no-unused-vars
      let { [detailLevelKey]: matches, ...rest } = detailLevels;
      for (const rArr in rest) {
        rest[rArr].forEach((r) => mismatches.push(r));
      }
    }
  };

  const geocodeLocations = (data, onResultsReceived, onComplete) => {
    let emptyResultsCount = 0;
    $.ajax({
      url: "/api/geocoder/geocode/",
      data: JSON.stringify(data),
      type: "POST",
      success: (data) => {
        getResultsInterval = setInterval(() => {
          $.ajax({
            url: "/api/geocoder/results/",
            data: JSON.stringify({ jobId: data.job }),
            type: "POST",
            success: (resultsData) => {
              if (!resultsData) {
                clearInterval(getResultsInterval);
              }

              if (resultsData.results.length === 0) {
                emptyResultsCount++;
              }

              onResultsReceived(resultsData);

              if (resultsData.status == "done" || emptyResultsCount > 10) {
                clearInterval(getResultsInterval);
                onComplete();
              }
            },
          });
        }, 1500);
      },
      error: console.error,
      dataType: "json",
      contentType: "application/json",
      processData: false,
    });
  };

  const handleMismatchResults = (resultsData) => {
    resultsData.results.forEach((result) => {
      if (result.results) {
        const r = mismatches[result.r];
        const bestMatch = result.results.find((address) =>
          address.types.includes(
            window.per.map_render_type.detailLevel.toLowerCase(),
          ),
        );

        if (bestMatch) {
          const row = window.per.mapRS[r];
          row.lt = bestMatch.geometry.location.lat;
          row.ln = bestMatch.geometry.location.lng;
          row.placeId = bestMatch.place_id;
        }
      }
    });
  };

  const handleOutlierRegeocodeResults = (resultsData) => {
    let seen = {};
    let resultsHandled = 0;
    let received = [];
    const finalResults = [];
    const start = Date.now();
    received.push(resultsData.results.length);
    //  handle results
    resultsData.results.forEach((result) => {
      if (!seen[result.r]) {
        const status = result.status;
        let results;
        if ("undefined" !== typeof result.results) {
          results = result.results[0];
        } else {
          results = result;
        }

        if (
          !status &&
          results &&
          results.ip &&
          results.latitude &&
          outliers[result.r]
        ) {
          const newMarkerPosition = new google.maps.LatLng(
            results.latitude,
            results.longitude,
          );

          if (recommendedBounds.contains(newMarkerPosition)) {
            if (!results.geometry) results.geometry = {};
            results.geometry.position = newMarkerPosition;
            results.r = outliers[result.r].r;
            results.outlierRow = result.r;
            results.formatted_address = (
              BatchGeo.ifstr(results.city) +
              " " +
              BatchGeo.ifstr(results.region_name) +
              " " +
              BatchGeo.ifstr(results.zipcode) +
              " " +
              BatchGeo.ifstr(results.country_name)
            ).trim();
            finalResults.push(results);
          }
        } else if (
          status === google.maps.GeocoderStatus.OK &&
          results &&
          outliers[result.r]
        ) {
          const newMarkerPosition = new google.maps.LatLng(
            results.geometry.location.lat,
            results.geometry.location.lng,
          );
          if (recommendedBounds.contains(newMarkerPosition)) {
            results.r = outliers[result.r].r;
            results.outlierRow = result.r;
            results.geometry.position = newMarkerPosition;
            finalResults.push(results);
          }
        }

        seen[result.r] = 1;
        resultsHandled++;
        if (resultsHandled === outliersStargingLength) {
          var curTime = new Date().getTime();
          window.per.gps = outliersStargingLength / ((curTime - start) / 1000);
        }
      }
    });

    if (finalResults.length) {
      // sort highest row to lowest for safe splicing
      finalResults.sort((a, b) => b.outlierRow - a.outlierRow);

      finalResults.forEach((result) => {
        const newLocation = result.geometry.position;
        const outlierRM = outliers[result.outlierRow];

        if (result.ip) {
          // ip specific rm updates
          outlierRM.accuracy = google.maps.GeocoderLocationType.APPROXIMATE;
          outlierRM.postal = result.zipcode;
          outlierRM.l = result.formatted_address;
        } else {
          // non-ip rm updates
          outlierRM.accuracy = result.geometry.location_type; // update accuracy
          outlierRM.postal = "";
          if (typeof locale !== "undefined" && locale != "us")
            outlierRM.l = result.formatted_address;
        }

        outlierRM.lt = newLocation.lat(); // update rm lt
        outlierRM.ln = newLocation.lng(); // update rm ln
        outlierRM.distance = Math.round(
          BatchGeo.distance(
            parseFloat(cogLatLon.lt),
            parseFloat(cogLatLon.ln),
            outlierRM.lt,
            outlierRM.ln,
          ),
        ).toFixed(2); // update rm distance

        if (BatchGeo.goodLatLon(outlierRM.lt, outlierRM.ln)) {
          // update geocode cache
          window.gC[rgn][outlierRM.addr] = {
            lt: outlierRM.lt,
            ln: outlierRM.ln,
            accuracy: outlierRM.accuracy,
            l: outlierRM.l,
          };
        }

        delete outlierRM.outlier; // delete outlier flag
        outliers.splice(result.outlierRow, 1);
      });
    }

    var sum = 0;
    for (let k = 0; k < received.length; k++) {
      sum += parseInt(received[k], 10);
    }
    var avg = sum / received.length;
    var gps = (received.length * avg) / (1.5 * received.length);
    if (received.length > 5) {
      received = [];
    }
    if (gps > 150) {
      gps = 150;
    }
    remaining = Math.round((outliersStargingLength - resultsHandled) / gps + 2);
  };

  const geoCodeOutliersWithRecommendedBounds = (outliers) => {
    // get outlier addresses
    const addrs = outliers.map((item) => item.addr);

    var senddata = [addrs, rgn, recommendedBounds.toUrlValue(), 0, breakcache];

    if (ip_addr === true) {
      senddata = [addrs, rgn, recommendedBounds.toUrlValue(), 1, breakcache];
    }

    // the actual outliers array is mutated so we snapshot the initial state
    const outliersCopy = [...outliers];
    const outliersStargingLength = outliersCopy.length;
    let ended = false;
    let showCount = 0;
    let remaining = 0;
    let resultsHandled = 0;
    showProcessingInterval = setInterval(function () {
      if (
        showCount < outliersStargingLength &&
        resultsHandled > 0 &&
        showCount < resultsHandled
      ) {
        showCount = resultsHandled - 1;
      }

      var remaintxt = "";
      if (remaining > 90) {
        remaintxt = Math.round(remaining / 60).toString() + " minutes to go";
      } else if (remaining > 60) {
        remaintxt = Math.round(remaining / 60).toString() + " minute to go";
      } else if (remaining > 0) {
        remaintxt = remaining.toString() + " seconds to go";
      }

      var $geocoderStatus = $("#geocoder_status");
      if (ended) {
        $geocoderStatus.html(
          "Done Processing Outliers:<br/>" +
            outliersCopy[outliersStargingLength - 1].addr +
            "<br/> (" +
            outliersStargingLength.toString() +
            "/" +
            outliersStargingLength +
            ")",
        );
      } else if (showCount < outliersStargingLength) {
        $geocoderStatus.html(
          "Now Processing Outlier:<br/>" +
            outliersCopy[showCount].addr +
            "<br/> (" +
            (showCount + 1).toString() +
            "/" +
            outliersStargingLength +
            ") " +
            remaintxt,
        );
      }
      showCount++;
    }, 80);

    geocodeLocations(
      senddata,
      handleOutlierRegeocodeResults,
      window.stopGeocode,
    );
  };

  const handlePotentialOutliers = () => {
    clearInterval(showProcessingInterval);
    statusText = "Handling potential outliers.";
    // find valid mapRS items
    const goodLatLonRM = window.per.mapRS.filter((rM) =>
      BatchGeo.goodLatLon(rM.lt, rM.ln),
    );

    if (!goodLatLonRM.length) {
      // no valid results, stop
      return window.stopGeocode();
    }

    // assign distance data to mapRS
    window.composeDistanceData(goodLatLonRM, false);
    // compose outlier data
    const outlierData = window.composeOutlierData(goodLatLonRM);
    outliers = outlierData.outliers;
    outliersByRowIndex = outlierData.outliersByRowIndex;

    if (!outliers.length) {
      // no outliers, stop
      return window.stopGeocode();
    }

    // generate bounds - use mapRS because marker may not exist yet
    validRM = goodLatLonRM.filter((rM) => !outliersByRowIndex[rM.r]);
    recommendedBounds = window.composeBounds(validRM);

    // attempts to geocode with recommended boundary and resolve any outliers
    geoCodeOutliersWithRecommendedBounds(outliers);
  };

  const handleMismatches = () => {
    statusText = "Handling mismatched results.";
    if (mismatches.length && window.per.map_render_type.type === "choropleth") {
      let latLngs = [];
      mismatches.forEach((mismatch) => {
        const { lt, ln } = window.per.mapRS[mismatch];
        latLngs.push(`${lt}, ${ln}`);
      });

      const data = [latLngs, rgn, window.gbounds.toUrlValue(), 0, breakcache];

      geocodeLocations(data, handleMismatchResults, handlePotentialOutliers);
    } else {
      handlePotentialOutliers();
    }
  };

  window.doGeocode = function () {
    if (BatchGeoStore.getState().App.over == "lite") {
      let upgrade =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/admin/subscription/#upgrade";
      BatchGeo.customAlert(
        'Your usage exceeded the geocoding limits of BatchGeo, please <a href="' +
          upgrade +
          '">upgrade to a Pro account</a>.',
      );
      return 0;
    }

    if (BatchGeoStore.getState().App.over == "free") {
      let upgrade =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/pricing/lite/";
      BatchGeo.customAlert(
        'You have exceeded the usage limits of the free tier, please <a href="' +
          upgrade +
          '">upgrade to Lite or Pro</a>.',
      );
      return 0;
    }

    window.curRow = 0;
    window.gbounds = new google.maps.LatLngBounds();

    if (!window.per.columnNames) {
      if (!window.source) {
        BatchGeo.customAlert(
          "You need to validate the source first, check Step #1.",
        );
        return 0;
      }
      if (!window.validateSource()) {
        return 0;
      }
    } else if (
      window.per.address_col < 0 &&
      window.per.city_col < 0 &&
      window.per.state_col < 0 &&
      window.per.zip_col < 0 &&
      window.per.country_col < 0 &&
      (window.per.lat_col < 0 || window.per.long_col < 0)
    ) {
      BatchGeo.customAlert(
        "No columns that can be geocoded are selected, check Step #2.",
      );
      return 0;
    } else if (window.working) {
      if (
        confirm("Are you sure you want to stop the current geocoding process?")
      ) {
        clearInterval(showProcessingInterval);
        return window.stopGeocode();
      } else {
        return 0;
      }
    }

    $("#geocoder_status, #geocoding, #geocoder_ad").css("display", "block");
    $("#geocodeshow_button").css("display", "inline");

    $("html, body").animate(
      {
        scrollTop: $("#geocoding").offset().top,
      },
      1000,
    );

    window.per.mapRS = window.per.mapRS || [];

    window.working = 1;
    window.curRow = 0;

    var $geocodeButton = $("#geocode_button");
    $("#geocoder_status, #geocoding, #geocoder_ad").css({ display: "block" });

    $("#geocoding")[0].scrollIntoView(true);

    // Cache the old button value to flip it back after we're done
    $geocodeButton.data("old-value", $geocodeButton.val());

    const strings =
      window.BatchGeoStrings.getStringsForComponent("BatchGeoGeoCoder");
    const stopGeocoderString = strings.get("STOP_GEOCODER");
    $geocodeButton.val(stopGeocoderString || "Stop Geocoder");
    $geocodeButton.removeClass("green").addClass("red");

    resetSharedGeocodeState();

    window.gC[rgn] = window.gC[rgn] || {};

    var addrs = [];
    var resultsHandled = 0;
    window.per.addrs_len = 0;

    for (var c = 0; c < window.per.mapRS.length; c++) {
      const rM = window.prepRow(c);
      if (rM === null) {
        console.log("bad row " + c);
        resultsHandled++;
        mismatches.push(c);
        continue;
      }
      let addr = rM.addr.trim();
      if (addr.toLowerCase() === "new york") {
        addr = `${addr} State`;
      }

      const isAddrValidString = Boolean(addr);
      if (!breakcache && !rM.lt && isAddrValidString && window.gC[rgn][addr]) {
        // cache available
        rM.lt = window.gC[rgn][addr].lt;
        rM.ln = window.gC[rgn][addr].ln;
        rM.accuracy = window.gC[rgn][addr].accuracy;
        rM.l = rM.l || window.gC[rgn][addr].l;
        resultsHandled++;
        continue; // continue to next iteration
      }

      const isLatLonGood = BatchGeo.goodLatLon(rM.lt, rM.ln);
      if (
        (breakcache || !isLatLonGood) &&
        addr.split(".").length == 4 &&
        parseInt(addr.split(".")[0]) >= 1 &&
        addr.length <= 15
      ) {
        // ip address
        ip_addr = true;
        addrs.push(addr);
        rvals.push(c);
      } else if ((breakcache || !isLatLonGood) && isAddrValidString) {
        // no lat long
        // valid address
        addrs.push(BatchGeo.stripAddressSubPremise(addr));
        rvals.push(c);
      } else {
        // address doesn't exist or latlon is valid
        resultsHandled++;
        // latLngCount ++;
        if (!rM.accuracy) {
          rM.accuracy =
            window.per.map_render_type.type === "choropleth"
              ? google.maps.GeocoderLocationType.APPROXIMATE
              : google.maps.GeocoderLocationType.ROOFTOP;
        }
      }
    }

    window.per.addrs_len = addrs.length;
    if (addrs.length === 0) {
      const currentRenderType = window.batchGeoGoogleMapsManager
        .getMap()
        .getRenderingType();
      if (currentRenderType === "VECTOR" && window.per.disableChoropleth) {
        if (window.per.disableChoropleth) {
          window.batchGeoGoogleMapsManager.getMap(true);
        }
      } else {
        if (window.per.map_render_type.type === "choropleth") {
          window.batchGeoGoogleMapsManager.getMap(true);
        }
      }

      return window.stopGeocode();
    }

    var senddata = [addrs, rgn, window.gbounds.toUrlValue(), 0, breakcache];

    if (ip_addr === true) {
      senddata = [addrs, rgn, window.gbounds.toUrlValue(), 1, breakcache];
    }

    showProcessingInterval = setInterval(function () {
      if (
        showCount < window.per.mapRS.length &&
        resultsHandled > 0 &&
        showCount < resultsHandled
      ) {
        showCount = resultsHandled - 1;
      }

      var remaintxt = "";
      if (remaining > 90) {
        remaintxt = Math.round(remaining / 60).toString() + " minutes to go";
      } else if (remaining > 60) {
        remaintxt = Math.round(remaining / 60).toString() + " minute to go";
      } else if (remaining > 0) {
        remaintxt = remaining.toString() + " seconds to go";
      }

      var $geocoderStatus = $("#geocoder_status");
      if (ended) {
        $geocoderStatus.html(
          "Done Processing:<br/>" +
            window.per.mapRS[window.per.mapRS.length - 1].addr +
            "<br/> (" +
            window.per.mapRS.length.toString() +
            "/" +
            window.per.mapRS.length +
            ")",
        );
      } else if (showCount < window.per.mapRS.length) {
        $geocoderStatus.html(
          "Now Processing:<br/>" +
            window.per.mapRS[showCount].addr +
            "<br/> (" +
            (showCount + 1).toString() +
            "/" +
            window.per.mapRS.length +
            ") " +
            remaintxt,
        );
      } else if (statusText) {
        $geocoderStatus.html(statusText);
      }
      showCount++;
    }, 80);

    geocodeLocations(senddata, handleResults, handleMismatches);
  };

  const closeOutlierMenu = function (
    boundary = null,
    wasClusterEnabled = false,
    wasHeatMapEnabled = false,
    zoomToMarkers = false,
  ) {
    // remove outlier-mode from parent container
    $("#mapDiv-outlierMenu-container").removeClass("outlier-mode");
    // remove outlier-mode from map and reset height
    $("#mapDiv").removeClass("outlier-mode").css("height", "450px");
    // empty outlier container
    $(".outlier-container").empty();
    // empty invalid container
    $(".invalid-container").empty();
    // hide invalid content
    $(".invalid-wrapper").toggle(false);
    // hide the menu
    $("#outlierMenu").css("display", "none");
    // remove zoom to boundary button
    $(".batchgeo-boundary-zoom").remove();
    if (boundary) {
      // remove boundary
      boundary.setMap(null);
    }
    if (zoomToMarkers) {
      // zoom to markers
      window.batchGeoGoogleMapsMarker.zoomToMarkers();
    }
    if (wasClusterEnabled) {
      // re enable clusters
      BatchGeoStore.dispatch({ type: "CLUSTER_ENABLE" });
    }
    if (wasHeatMapEnabled) {
      // re enable heatmap
      BatchGeoStore.dispatch({ type: "HEATMAP_ENABLE" });
    }
    if (window.per.group_by_sel !== -1) {
      // render legwrap/marker legend if needed
      $("#legWrap").css("display", "block");
    }
  };

  const removeOutlier = (mapRSIndex, simulateMouseLeave = false) => {
    // remove from list
    const _p = $(`p.outlier-${mapRSIndex}`);
    if (simulateMouseLeave) {
      _p.trigger("mouseleave");
    }
    _p.remove();
    // remove from map
    const markers = window.batchGeoGoogleMapsMarker.getMarkers();
    const markerObj = window.batchGeoGoogleMapsMarker.getMarkersAsObject();
    let targetMarker;
    let targetIndex;
    markers.forEach((marker, index) => {
      if (marker.r === mapRSIndex) {
        targetMarker = marker;
        targetIndex = index;
      }
    });

    if (targetMarker) {
      targetMarker.setMap(null);
      markers.splice(targetIndex, 1);
      if (markerObj[targetMarker.r]) {
        delete markerObj[targetMarker.r];
      }
    }
    // update mapRS
    window.per.mapRS[mapRSIndex].lt = 0;
    window.per.mapRS[mapRSIndex].ln = 0;
    window.per.mapRS[mapRSIndex].accuracy = "unknown";
  };

  const sendMessageToMapPreview = (mapPreviewContainer, message) => {
    const previewContainer = document.getElementById(mapPreviewContainer);
    previewContainer.contentWindow.postMessage(message, "*");
  };

  const showMapPreview = (mapReset) => {
    if (mapReset && displayChoroplethOption) {
      window.per.map_render_type = { type: "choropleth", detailLevel };
      window.batchGeoGoogleMapsManager.getMap(true);
    }

    const $geocoderStatus = $("#geocoder_status");
    $(".mapBorder").removeClass("hide");
    BatchGeoStore.getState().MarkerDrawer.shouldDraw = true;
    window.batchGeoGoogleMapsManager.doMap(mapReset);
    if ($geocoderStatus.length) {
      $("html, body").animate(
        {
          scrollTop: $geocoderStatus.offset().top,
        },
        1000,
      );
    }

    // scroll preview fully into view
    // map-preview doesn't exist on the edit page
    const mapPreview = document.getElementById("map-preview");
    if (mapPreview) {
      $("html, body").animate(
        {
          scrollTop: $("#map-preview").offset().top,
        },
        1000,
      );
    }
  };

  const buildUnmappable = () => {
    let fail = "";
    let failCount = 0;
    window.per.mapRS
      .filter((row) => row.invalid || !BatchGeo.goodLatLon(row.lt, row.ln))
      .forEach((invalidRow) => {
        fail += `Row ${invalidRow.r}: ${invalidRow.addr || "(empty)"} <br />`;
        failCount++;
      });

    if (fail.length || outliers.length) {
      let wasHeatMapEnabled = false;
      let wasClusterEnabled = false;
      let boundary = null;

      if (outliers.length) {
        // disable heatmap and cluster
        const { Cluster, HeatMap } = BatchGeoStore.getState();
        if (Cluster && Cluster.enabled) {
          wasClusterEnabled = true;
          BatchGeoStore.dispatch({ type: "CLUSTER_DISABLE" });
        }

        if (HeatMap && HeatMap.enabled) {
          wasHeatMapEnabled = true;
          BatchGeoStore.dispatch({ type: "HEATMAP_DISABLE" });
        }

        // log outlier data
        window.dispatchOutlierData(outliers, validRM);

        // add outliers to the outliers container
        const _outlierContainer = $(".outlier-container");
        outliers.forEach((outlier) => {
          const _p = $("<p>");
          _p.addClass(`outlier-${outlier.r}`);
          _p.attr("data-id", outlier.r);
          _p.html(
            `<button class="remove-outlier" data-id="${outlier.r}"><img src="/images/icons/red_x@2x.png" /></button> <span>Row ${outlier.r + 2}:</span>${outlier.addr}`,
          );

          _p.on("mouseenter", (e) => {
            const current = e.currentTarget;
            const index = Number(current.getAttribute("data-id"));
            const marker = window.batchGeoGoogleMapsMarker.getMarker(index);
            if (marker) {
              google.maps.event.trigger(marker, "mouseover");
              marker.setIcon(marker.activeIcon);
            }
          });

          _p.on("mouseleave", (e) => {
            const current = e.currentTarget;
            const index = Number(current.getAttribute("data-id"));
            const marker = window.batchGeoGoogleMapsMarker.getMarker(index);
            if (marker) {
              google.maps.event.trigger(marker, "mouseout");
              marker.setIcon(marker.defaultIcon);
            }
          });

          _outlierContainer.append(_p);
        });

        boundary = window.buildRectangle(recommendedBounds);
        window.addZoomToBoundaryButton(boundary);

        // button listeners
        $("button.remove-outlier").on("click", (e) => {
          const index = Number(e.currentTarget.getAttribute("data-id"));
          removeOutlier(index, true);
          if (window.addAccuracyInfo) {
            window.addAccuracyInfo();
          }
        });

        $("button.keep-all").on("click", () => {
          const markersByRowNum =
            window.batchGeoGoogleMapsMarker.getMarkersAsObject();

          const outlierMarkers = outliers.map(
            (outlier) => markersByRowNum[outlier.r],
          );

          outlierMarkers.forEach((marker) => {
            if (marker && marker.getMap()) {
              delete window.per.mapRS[marker.r].outlier;
            }
          });

          closeOutlierMenu(boundary, wasClusterEnabled, wasHeatMapEnabled);
        });

        $("button.discard-outside").on("click", () => {
          const bounds = boundary.getBounds();

          let deletableMarkers = [];
          const markers = window.batchGeoGoogleMapsMarker.getMarkers();
          markers.forEach((marker, index) => {
            if (!bounds.contains(marker.getPosition())) {
              // out of bounds
              deletableMarkers.push({ marker, index });
            }

            const rM = window.per.mapRS.find((rM) => rM.r === marker.r);
            if (
              rM &&
              window.per.map_render_type.type === "choropleth" &&
              !rM.boundaryAvailable
            ) {
              deletableMarkers.push({ marker, index });
            }
          });

          const rMByRowNum = window.per.mapRS.reduce((acc, curr) => {
            acc[curr.r] = curr;
            return acc;
          }, {});

          deletableMarkers.sort((a, b) => b.index - a.index);

          const table = $("#sourceWrap table");

          deletableMarkers.forEach((item) => {
            const marker = item.marker;
            const rM = rMByRowNum[marker.r];
            const markerIndex = item.index;

            // if the table exists, delete the relevant row
            // off by 1 => the table has a header that takes up the [0] slot
            //          => array indexing is used for the row, so also off by 1.
            //          => example: marker.r where r = 5 would mean the 6th row in table
            //          => table.children('tr')[0] -> header
            //          => table.children('tr')[1] -> r.0
            //          => ...
            //          => table.children('tr)[6] -> r.5
            // the row to delete is one ahead of where the .r property identifies
            if (table) {
              const tr = table.children("tr")[marker.r + 1];
              if (tr) {
                tr.remove();
              }
            }

            marker.setMap(null); // remove marker from map
            markers.splice(markerIndex, 1); // remove marker from data

            rM.lt = 0;
            rM.ln = 0;
            rM.accuracy = "unknown";

            if (!rM.outlier) {
              rM.outlier = true;
            }

            // remove the data from the mapRS / dataRS arrays
            window.per.mapRS.splice(marker.r, 1);
            window.per.dataRS.splice(marker.r, 1);
          });

          // updating the .r property on the mapRS[x] object after rows have been 'refactored'
          window.per.mapRS = window.per.mapRS.map((rowData, index) => {
            rowData.r = index;
            return rowData;
          });

          if (window.addAccuracyInfo) {
            window.addAccuracyInfo();
          }

          closeOutlierMenu(
            boundary,
            wasClusterEnabled,
            wasHeatMapEnabled,
            true,
          );
        });
      } else {
        // no outliers, just reset the map
        $("button.keep-all").on("click", () => {
          closeOutlierMenu(boundary, wasClusterEnabled, wasHeatMapEnabled);
        });

        $("button.discard-outside").on("click", () => {
          closeOutlierMenu(boundary, wasClusterEnabled, wasHeatMapEnabled);
        });
      }

      if (fail.length) {
        // add bad addresses to the invalid container
        $(".invalid-wrapper").toggle(true);
        $(".invalid-container").html(`<p>${fail}</p>`);
      }

      // setup the outlier menu
      $("#mapDiv-outlierMenu-container").addClass("outlier-mode"); // toggles flex
      $("#mapDiv").addClass("outlier-mode").css("height", "auto"); // toggles width and height
      $("#outlierMenu").css("display", "block"); // toggles outlier menu visibility
      $("#legWrap").css("display", "none"); // toggles marker legend
      $("#save_map").on("click", () => {
        // allow user to skip menu
        closeOutlierMenu(boundary, wasClusterEnabled, wasHeatMapEnabled);
      });

      $("#geocode_button").on("click", () => {
        closeOutlierMenu(boundary, wasClusterEnabled, wasHeatMapEnabled);
      });

      $("button.edit-data").on("click", () => {
        $(".tableize-wrapper").trigger("click");
        $("#sourceWrap")[0]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      });
    }

    return failCount;
  };

  const handleMapTypeSelection = (isChoropleth) => {
    if (isChoropleth) {
      window.per.disableChoropleth = false;
      window.per.map_render_type = { type: "choropleth", detailLevel };
    } else {
      window.per.disableChoropleth = true;
      window.per.map_render_type = { type: "marker" };
    }

    buildUnmappable();
    showMapPreview(true);
  };

  const showChoicePreview = () => {
    sendMessageToMapPreview("marker-preview", {
      type: "preview",
      mapData: { ...window.per, isMapPreview: true },
    });

    sendMessageToMapPreview("choropleth-preview", {
      type: "preview",
      mapData: {
        ...window.per,
        isMapPreview: true,
        disableChoropleth: false,
        map_render_type: {
          type: "choropleth",
          detailLevel,
        },
      },
    });

    const markerPreviewOverlay = $("#map-choice-marker");
    const markerPreview = $("#marker-preview");
    const choroplethPreviewOverlay = $("#map-choice-choropleth");
    const choroplethPreview = $("#choropleth-preview");
    markerPreviewOverlay.on("mouseenter", () => {
      markerPreview.addClass("selected");
    });

    choroplethPreviewOverlay.on("mouseenter", () => {
      choroplethPreview.addClass("selected");
    });

    markerPreviewOverlay.on("mouseleave", () => {
      markerPreview.removeClass("selected");
    });

    choroplethPreviewOverlay.on("mouseleave", () => {
      choroplethPreview.removeClass("selected");
    });

    $("#map-choice-marker").click(() => {
      handleMapTypeSelection(false);
    });

    $("#map-choice-choropleth").click(() => {
      handleMapTypeSelection(true);
    });

    $(".map-choice-preview").removeClass("hide");
  };

  window.stopGeocode = function () {
    ended = true;

    window.working = 0;

    clearInterval(getResultsInterval);
    clearInterval(showProcessingInterval);

    var $geocodeButton = $("#geocode_button");
    $geocodeButton
      .val($geocodeButton.data("old-value"))
      .removeClass("red")
      .addClass("green");

    var $results = $("#results");
    var $geocoderStatus = $("#geocoder_status");

    $geocoderStatus.css("display", "inline");
    $results.css("display", "block");

    if (
      (BatchGeoStore.getState().App.pro ||
        !BatchGeoStore.getState().Generator.dataChanged) &&
      !BatchGeoStore.getState().App.isEdit &&
      displayChoroplethOption
    ) {
      showChoicePreview();
    } else {
      showMapPreview();
    }

    if ($geocoderStatus.length) $geocoderStatus[0].scrollIntoView(true);
    const failCount = buildUnmappable();
    $geocoderStatus.html(
      "Geocoded " + (window.per.mapRS.length - failCount) + " records.",
    );

    $("#dragmsg").toggle(window.per.mapRS.length > 100);
    if (window.addAccuracyInfo) {
      window.addAccuracyInfo();
    }

    if (BatchGeoStore.getState().App.isEdit) {
      $("#save").show();
    }
  };

  window.calculateCenterOfGravity = function (coordinates) {
    if (coordinates.length === 0) {
      return null; // No coordinates provided
    }

    // Convert latitude and longitude to radians
    const toRadians = (degrees) => degrees * (Math.PI / 180);

    // Convert radians to degrees
    const toDegrees = (radians) => radians * (180 / Math.PI);

    let xSum = 0;
    let ySum = 0;
    let zSum = 0;

    // Calculate Cartesian coordinates
    for (let i = 0; i < coordinates.length; i++) {
      const latRad = toRadians(coordinates[i].lt);
      const longRad = toRadians(coordinates[i].ln);

      xSum += Math.cos(latRad) * Math.cos(longRad);
      ySum += Math.cos(latRad) * Math.sin(longRad);
      zSum += Math.sin(latRad);
    }

    // Calculate average Cartesian coordinates
    const xAvg = xSum / coordinates.length;
    const yAvg = ySum / coordinates.length;
    const zAvg = zSum / coordinates.length;

    // Convert Cartesian coordinates back to latitude and longitude
    const centerLatRad = Math.atan2(zAvg, Math.sqrt(xAvg ** 2 + yAvg ** 2));
    const centerLongRad = Math.atan2(yAvg, xAvg);

    // Convert radians to degrees
    const centerLat = toDegrees(centerLatRad);
    const centerLong = toDegrees(centerLongRad);

    return { lt: centerLat, ln: centerLong };
  };

  window.composeDistanceData = function (validCoords, returnable) {
    // get center of gravity
    cogLatLon = window.calculateCenterOfGravity(validCoords);
    const { lt, ln } = cogLatLon;

    validCoords.forEach((rM) => {
      var distance = Math.round(
        BatchGeo.distance(parseFloat(lt), parseFloat(ln), rM.lt, rM.ln),
      ).toFixed(2);
      rM.distance = distance; // string
    });

    if (returnable) {
      // accumulate distance data
      const distancesByAddr = {};
      const rawDistances = [];
      validCoords.forEach((rM) => {
        const currDistance = parseFloat(rM.distance);
        distancesByAddr[rM.addr] = currDistance;
        rawDistances.push(currDistance);
      });
      return { distancesByAddr, rawDistances };
    }
  };

  /**
   * Composes outlier data by evaluating distance from center of gravity
   *
   * Steps:
   * Sort data by distance from center of gravity.
   * Loop the top 5% of sorted data and create breakpoints where difference in distance meets a minimum theshold and a multiple threshold.
   * Determine best outlier breakpoint, if any, where breakpoint makes up a non-significant portion of the total data.
   *
   */
  window.composeOutlierData = function (validData) {
    // copy and sort data
    const copy = [...validData];
    copy.forEach((item) => parseFloat(item.distance));
    copy.sort((a, b) => a.distance - b.distance);

    const dataToEvaluate = copy.slice(copy.length * 0.95); // only check the top 5% of distances

    const LAST_DISTANCE_MULTIPLIER = 1.75; // adjust to impact overall results
    const MIN_MILES_DIF = 40; // adjust to impact local results

    const distanceBreakPoints = dataToEvaluate.reduce(
      (acc, curr, index, arr) => {
        if (index !== 0) {
          const prev = arr[index - 1];
          const prevDistance = prev.distance;
          const prevThreshold = prevDistance * LAST_DISTANCE_MULTIPLIER; // current marker must be greater than this
          const currDistance = curr.distance;
          const difference = currDistance - prevDistance;
          const multiple = currDistance / prevDistance; // current

          if (
            prevThreshold <= currDistance &&
            MIN_MILES_DIF <= difference &&
            LAST_DISTANCE_MULTIPLIER < multiple
          ) {
            const valuesAfter = arr.slice(index);
            const length = valuesAfter.length;
            acc.push({
              outliers: valuesAfter,
              pct: parseFloat(((length / copy.length) * 100).toFixed(2)),
              count: length,
              difference,
              multiple: parseFloat(multiple.toFixed(2)),
            });
          }
        }
        return acc;
      },
      [],
    );

    // evaluate groups
    const breakPointOfChoice = distanceBreakPoints.find((group) => {
      return group.pct < 0.75 || group.outliers.length === 1;
    });

    let outliers = [];
    if (breakPointOfChoice) {
      outliers = breakPointOfChoice.outliers;
    }

    outliers.forEach((outlier) => (outlier.outlier = true));

    const outliersByRowIndex = outliers.reduce((acc, curr) => {
      acc[curr.r] = curr;
      return acc;
    }, {});

    return { outliers, outliersByRowIndex };
  };

  window.composeBounds = function (markers) {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach((marker) => {
      bounds.extend(new google.maps.LatLng(marker.lt, marker.ln));
    });
    return bounds;
  };

  window.buildRectangle = function (startingBounds) {
    // create adjustable rectangle and add it to map
    const rectangle = new google.maps.Rectangle({
      bounds: startingBounds,
      editable: true,
      strokeColor: "#B64545",
      fillColor: "#95EA7B",
      fillOpacity: 0.5,
      map: window.batchGeoGoogleMapsManager.getMap(),
    });

    return rectangle;
  };

  window.dispatchOutlierData = function (outlierData, validData) {
    // outlier item data
    const outliers = outlierData.map((item) => ({
      id: item.r.toString(),
      data: item.addr,
    }));

    // outlier meta data
    const detected = `${outlierData.length}/${window.per.mapRS.length}`;
    const rate = ((outlierData.length / window.per.mapRS.length) * 100).toFixed(
      2,
    );
    const avgDist = (
      validData.reduce((acc, curr) => (acc += parseFloat(curr.distance)), 0) /
      validData.length
    ).toFixed(2);
    const outlierAvgDistFactor = (outlierData[0].distance / avgDist).toFixed(2);

    const outlierMetaData = {
      detected,
      rate,
      isMeta: true,
      outlierAvgDistFactor,
      avgDist,
    };
    outliers.push(outlierMetaData);

    //store the outliers in state
    //we dont have a mapId to associate these outliers to any particular map
    BatchGeoStore.dispatch({
      type: "OUTLIERS_DETECTED",
      outliers,
    });
  };

  window.addZoomToBoundaryButton = function (boundary) {
    const container = $("#mapDiv .batchgeo-custom-buttons");
    return $("<button />", {
      addClass: "batchgeo-boundary-zoom",
      text: "Zoom To Boundary",
      type: "button",
      toggle: true,
      click: (e) => {
        const currentBounds = boundary.getBounds();
        // get map
        const map = window.batchGeoGoogleMapsManager.getMap();
        // fit map to bounds
        map.fitBounds(currentBounds);
        // set map center
        map.setCenter(currentBounds.getCenter());
        // simulate dragend to trigger event listener in batchgeo-custom-extents.js
        google.maps.event.trigger(map, "dragend");

        // disable button
        const thisButton = $(e.target);
        thisButton.toggle(false);

        // declare listener variables
        let zoomChangedListener;
        let dragEndListener;
        let boundaryResizeListener;

        // dry event handler
        const enableButtonAndCancelListener = (listenerToCancel) => {
          thisButton.toggle(true);
          if (listenerToCancel) {
            google.maps.event.removeListener(listenerToCancel);
          }
        };

        // one time event(s) that re enables 'zoom to boundary' button and cancels the other listener
        zoomChangedListener = google.maps.event.addListenerOnce(
          map,
          "zoom_changed",
          () => enableButtonAndCancelListener(dragEndListener),
        );
        dragEndListener = google.maps.event.addListenerOnce(
          map,
          "center_changed",
          () => enableButtonAndCancelListener(zoomChangedListener),
        );
        boundaryResizeListener = google.maps.event.addListenerOnce(
          boundary,
          "bounds_changed",
          () => enableButtonAndCancelListener(boundaryResizeListener),
        );
      },
    }).appendTo(container);
  };
})();
